import { h } from 'preact';
import * as BaseComp from 'components/bolt/landscapeOverlay/landscapeOverlay.js';
import HTML from 'components/core/html/html';
import Phone from 'components/bolt/icons/phone';
import Store from 'store/store';
import s from 'components/bolt/landscapeOverlay/landscapeOverlay.sss';

export default class LandscapeOverlay extends BaseComp.default {
	render() {
		const copy = Store.get().appData?.copy?.baseCopy;
		const prompt = copy?.$PORTRAIT_PROMPT;
		return (
			<div className={s.wrapper}>
				<Phone class={s.phoneIcon} />
				<HTML markdown content={prompt} class={s.prompt} />
			</div>
		);
	}
}
